
    // A failed save sends the ids of every erroring input. The one the seafarer
    // should see first is simply the first of them in the document, so we let the
    // DOM say which that is, then switch to the page holding it. The page sections
    // are hidden by class rather than removed, so an input on a page that is not
    // showing is still there to be found and walked up from.
    //
    // Each page section carries its own name in `data-page`, so this reads the
    // name off the element instead of parsing it out of the id. A test asserts
    // every page the server knows about renders that attribute.
    export default {
      mounted() {
        this.handleEvent("focus_first_error", ({ ids }) => {
          const selector = (ids || []).map((id) => `#${CSS.escape(id)}`).join(",")
          if (!selector) return

          const input = document.querySelector(selector)
          const section = input && input.closest("[data-page]")
          if (!section) return

          const page = section.dataset.page
          this.pushEvent("switch_page", { page }, () => {
            input.focus({ preventScroll: true })
            input.scrollIntoView({ block: "center", behavior: "smooth" })
          })
        })
      },
    }
  